import * as React from "react";
const SvgIcoInactiveAccount = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ...props }, /* @__PURE__ */ React.createElement("path", { id: "remove", d: "M9,0a9,9,0,1,0,9,9A9.01,9.01,0,0,0,9,0Zm4.5,10.125h-9V7.875h9Z", fill: "#c30909" }));
export default SvgIcoInactiveAccount;
